import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Dropdown, Modal } from "react-bootstrap";
import PerfectScrollbar from 'perfect-scrollbar';
import coins from "../../../coins";
import socket from "../../../../Socket";
import storage from "../../../../Storage";
import { setCoin, gameCoin, setCredit } from "../../../../actions/gameCoin";
import { __, wait, decode, encode, forceSatoshiFormat, Event } from "../../../../Helper";
import C from "../../../../Constant";

import RollingBalance from "../../../Components/Common/RollingBalance";

class Credit extends React.Component {
    constructor(props) {
        super(props);
        // Helper to extract numeric credit value from storage (may be number or object)
        const storedCredit = storage.getKey('credit');
        const initialCredit = typeof storedCredit === 'object'
            ? (storedCredit?.kshs ?? 0)
            : (storedCredit ?? 0);

        this.state = {
            show: false,
            token: storage.getKey('token'),
            coin: "KES",
            activeClientCoins: storage.getKey('active_coins') ? storage.getKey('active_coins') : null,
            selectedCoin: 'kshs',
            credits: {},
            coins: [],
            different: [],
            credit: initialCredit
        };
        this.wrapperRef = React.createRef();

        this.updateCredit = this.updateCredit.bind(this);
    }

    componentDidMount() {
        storage.setKey('coin', 'kshs')

        //Get Redux Coin
        this.props.gameCoin();
        if (this.state.token !== null)
            socket.emit(C.CREDIT, encode({ token: this.state.token, coin: this.state.coin }));

        socket.on(C.CREDIT, data => this.getCredit(decode(data)));
        socket.on(C.UPDATE_CREDIT, data => this.updateCredit(decode(data)));

        Event.on(C.UPDATE_CREDIT, data => this.updateCredit(data));
    }

    componentWillUnmount() {
        Event.off(C.UPDATE_CREDIT, this.updateCredit);
    }

    getCredit(data) {
        let { credit } = data;

        this.setState({ credits: credit });

        // Use 'kshs' key to match server response format
        let currentCredit = credit?.kshs ?? 0;
        this.setState({ credit: currentCredit });
        storage.setKey('credit', currentCredit);


        //Set for Redux
        this.props.setCredit(currentCredit);
    }

    updateCredit(data) {

        let credit = data.value;
        let coin = data.coin;

        let different;
        let arr;

        if (__.toNumber(credit) > __.toNumber(this.state.credit)) {
            different = __.toNumber(credit) - __.toNumber(this.state.credit);
            arr = {
                amount: different,
                color: 'text-success'
            }
        }
        else {
            different = __.toNumber(this.state.credit) - __.toNumber(credit);
            arr = {
                amount: different,
                color: 'text-danger'
            }
        }

        let check = forceSatoshiFormat(different);

        if (check.toString() !== '0.00000000') {
            this.setState(state => ({ different: [arr, ...state.different] }));
        }

        this.setState({ credit: credit });
        storage.setKey('credit', credit);
        //Set for Redux
        this.props.setCredit(credit);

        // Pass `check` as a prop to the child component
        // this.props.onCheckChange(check);
    }

    addDiff(data, i) {
        let id = 'id_' + Math.floor(Math.random() * 1000 + 1);

        wait(2000).then(() => {
            try {
                document.getElementById(id).classList.remove('frd');
                document.getElementById(id).classList.add('fadeOutDown');
            }
            catch (e) { }
            this.state.different.splice(i, 1);
        });

        return <li key={i} id={id} className={'list-inline w-100 text-right animated frd ' + data.color}> {(data.color === 'text-danger' ? '-' : '+')}
            {forceSatoshiFormat(data.amount, this.state.coin)}
        </li>;
    }

    render() {
        let { credit, different, coin, coins, show } = this.state;
        let diff = different.map((data, i) =>
            this.addDiff(data, i)
        );

        const { t } = this.props;
        return (
            <>
                <div className="header-balance-pill" ref={this.wrapperRef}>
                    <div className="balance-label">KES</div>
                    <div className="balance-value">
                        <RollingBalance value={credit} />
                    </div>
                    <ul id="cup2" className="list-inline m-0 position-absolute" style={{ top: '-25px', right: '10px' }}>{diff}</ul>
                </div>
            </>
        );
    }
}

Credit.propTypes = {
    setCoin: PropTypes.func.isRequired,
    coin: PropTypes.string,
    // wonAmount: PropTypes.func.isRequired 
};

const mapStateToProps = state => ({
    coin: state.items.coin
});

export default connect(mapStateToProps, { setCoin, gameCoin, setCredit })(Credit);